<template>
  <div
    class="pageWrapper main_container"
    style="padding: 0"
  >
    <div
      class="wrapper"
      :class="{'younesis': isYounesisProject, 'bodybase': isBodybaseProject}"
      :style="{'--product-welcome-background': welcomeBackgroundURL}"
    >
      <template
        v-if="isYounesisProject || isBodybaseProject"
      >
        <div
          class="background"
        />
        <div
          class="splash"
        >
          <div
            class="circle1"
          />

          <div
            class="circle2"
          />

          <div
            class="circle3"
          />

          <div
            v-if="!isYounesisProject"
            class="logoURL"
            :style="{ backgroundImage: store.state.app?.appIcons?.logoBgUrl186x84 }"
          />

          <div
            class="title"
          >
            <Typography
              :variant="isYounesisProject ? 'h2' : 'v32-900-caps-italic'"
              center
              style="margin-bottom: 8px"
            >
              {{ t(`guest:Welcome.Title.${store.state.app?.appData?.pageTitle}`) }}
            </Typography>

            <Typography
              variant="v16-400"
              color="primary"
              style="line-height: 22px; padding: 0 24px"
              center
            >
              {{ t(`guest:Welcome.Text.${store.state.app?.appData?.pageTitle}`) }}
            </Typography>
          </div>

          <div
            class="art"
            :style="{ backgroundImage: welcomeImgURL }"
          />
        </div>
      </template>
      <template
        v-else
      >
        <div
          class="splashScreen"
        >
          <div
            class="splashLogo"
          />
        </div>
      </template>
    </div>

    <div
      class="main_container"
    >
      <div
        class="buttons"
      >
        <AppButton
          full-width
          size="large"
          @click="() => router.push({name: 'Register'})"
        >
          {{ t("guest:Action.Register") }}
        </AppButton>
        <AppButton
          full-width
          variant="secondary"
          size="large"
          @click="() => router.push({name: 'LogIn'})"
        >
          {{ t("guest:Action.Login") }}
        </AppButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import AppButton from '@/components/UI/AppButton.vue'
import Typography from '@/components/UI/Typography.vue'
import {router} from '@/router/router.js'
import store from '@/store/store.js'
import {t} from 'i18next'
import {product} from '@product/product.js'

const isYounesisProject = computed(() => store.getters['app/isYounesisProject'])
const isBodybaseProject = computed(() => store.getters['app/isBodybaseProject'])
const welcomeImgURL = computed(() => `url("${product.assets.welcome}")`)
const welcomeBackgroundURL = product.assets.welcomeBackground
  ? `url("${product.assets.welcomeBackground}")`
  : 'none'
</script>

<style lang="scss" scoped>

.wrapper {
  flex-grow: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  &:after {
    content: " ";
    display: block;
    position: absolute;
    height: 100px;
    background: linear-gradient(0deg, rgba(23, 23, 23, 1) 0%, rgba(23, 23, 23, 0) 100%);
    bottom: -1px;
    left: 0;
    right: 0;
  }

  .circle1,
  .circle2,
  .circle3 {
    border: 1px solid rgba(207, 46, 46, 0.6);
    position: absolute;
    border-radius: 50%;
    border-bottom: none;
  }



  &.younesis {
    .circle1,
    .circle2 {
      //border-right: none;
      //border-left: none;
    }
    .circle1 {
      top: 48%;
      transform: translateY(-50%);
      width: 297px;
      height: 297px;
    }

    .circle2 {
      top: 48%;
      transform: translateY(-50%);
      width: 377px;
      height: 377px;
      opacity: 0.35;
    }

    .circle3 {
      top: 48%;
      transform: translateY(-50%);
      width: 472px;
      height: 472px;
      opacity: 0.15;
    }

    .background {
      width: 100%;
      height: 100%;

      background-size: cover;
      background-repeat: no-repeat;
      background-position: top center;
      background-image: var(--product-welcome-background);
    }

    .splash {
      .art {
        top: 0;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        position: relative;
        width: 300px;
        height: 300px;
      }
    }
  }

  &.bodybase {
    .circle1,
    .circle2 {
      rotate: -60grad;
      border-left: none;
    }

    .circle3 {
      display: none;
    }

    .circle1 {
      top: 0;
      width: 160vw;
      height: 160vw;
      left: 0;
    }
    .circle2 {
      top: 45px;
      left: 45px;
      width: 140vw;
      height: 140vw;
    }
  }

  .background {
    position: absolute;
  }

  &.bodybase {
    .background {
      width: 165vw;
      height: 165vw;
      background: radial-gradient(rgba(163, 44, 0, 1) 0%, rgba(207, 46, 46, 0.1) 60%, rgba(0, 0, 0, 0) 100%);
    }
    .splash {
      .art {
        top: 130px;
        flex-grow: 1;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom center;
        position: relative;
        width: 100%;
      }
    }
  }
}

.title {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  z-index: 2;
  padding: 0 25px;
}


.splash {
  flex-grow: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}



.pageWrapper {
  min-height: 100vh;
  max-height: 100vh;
  min-height: 100svh;
  max-height: 100svh;
  display: flex;
  flex-direction: column;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 0;
}

.logoURL {
  top: calc(200px - 122px);
  background-size: contain;
  background-repeat: no-repeat;
  left: calc(50% - 93px);
  width: 186px;
  height: 84px;
  position: absolute;
}

.splashScreen {
  background-color: var(--app-background-color);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  .splashLogo {
    height: var(--logo-splash-height, 90px);
    width: var(--logo-splash-width, 200px);
    background-image: var(--logo-splash-src);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
}



</style>
